export const parseNumberValue = (
  num: number | null | undefined,
  isPercent: boolean = false,
  withSuffix: boolean = true
): string => {
  if (num === null || num === undefined) {
    return '–';
  } else {
    return String(
      new Intl.NumberFormat(
        'ua-UK',
        {
          style: isPercent ? 'percent' : 'decimal',
          notation: withSuffix ? 'compact' : 'standard',
          maximumFractionDigits: 2,
          compactDisplay: 'short'
        }
      )
        .format(num)
    );
  }
};
